"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CarrierInvoices {
    constructor() {
        this.auditStatus = 'Unaudited';
    }
}
exports.CarrierInvoices = CarrierInvoices;
//# sourceMappingURL=CarrierInvoices.js.map